// extracted by mini-css-extract-plugin
export var createdDate = "_ll-1";
export var divider = "_ll-2";
export var headerDivider = "_ll-3";
export var messagesCard = "_ll-0";
export var messagesContainer = "_ll-6";
export var messagesContainerWrapper = "_ll-4";
export var showLeftPanelButton = "_ll-8";
export var topButtons = "_ll-7";
export var withPadding = "_ll-5";